import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionButton } from './IFSShippingDashboard.styles';
export const PAGE_SIZE = 24;
const Pager = ({ page, total, onChange }) => {
    const pages = Math.ceil(total / PAGE_SIZE);
    if (pages <= 1)
        return null;
    return (_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: '0.75rem', justifyContent: 'center', marginTop: '1rem' }, children: [_jsx(ActionButton, { onClick: () => onChange(page - 1), disabled: page === 0, style: { padding: '0.4rem 0.75rem' }, children: "Prev" }), _jsxs("span", { style: { color: 'var(--text-secondary)', fontSize: '0.85rem' }, children: ["Page ", page + 1, " of ", pages, " (", total.toLocaleString(), " total)"] }), _jsx(ActionButton, { onClick: () => onChange(page + 1), disabled: page >= pages - 1, style: { padding: '0.4rem 0.75rem' }, children: "Next" })] }));
};
export default Pager;
